import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=0952c212&lang=pug&"
import script from "./menu.vue?vue&type=script&lang=coffee&"
export * from "./menu.vue?vue&type=script&lang=coffee&"
import style0 from "./menu.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports